import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonModule as NimbusCommonModule } from '../common/common.module';
import { RouterModule } from '@angular/router';
import { ErrorComponent } from './error.component';

@NgModule({
  imports: [
    CommonModule,
    NimbusCommonModule,
    RouterModule.forRoot([
      {
        path: '404',
        component: ErrorComponent
      }
    ])
  ],
  declarations: [
    ErrorComponent
  ],
  providers: [],
  exports: [
    ErrorComponent
  ]
})
export class ErrorsModule { }
